<template>
 <div>
  <el-row style="margin-bottom:10px;">
    <el-col :span="18" class='flex'>
      <el-select v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
          <el-option
              v-for="item in getProjectList_data.data||[]"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId">
          </el-option>
      </el-select>
      <el-select v-model='sfStatus' clearable @change="sfStatusChange" size="small" placeholder="选泽状态" style="margin:0 10px;">
          <el-option
              v-for="item in sfStatusAll"
              :key="item.id"
              :label="item.name"
              :value="item.id" >
          </el-option>
      </el-select>
      <el-input
        v-model="getSysFeedbackList_data.sfContext"
        placeholder="请输入反馈内容"
        clearable
        size='small'
        style="max-width:200px;"/>
      <el-button
        v-click.getSysFeedbackList
        type="primary"
        icon='el-icon-search'
        size='small'
        style='margin-left:10px;'
      >搜索
      </el-button>
    </el-col>
  </el-row>
	<mytable
	  :tableColums='tableColums_getSysKeyList'
	  api='getSysFeedbackList'
	  xupdateapi='updateSysHelp'
	  :height="H-163" >
	  <div slot="sfContext" slot-scope="{row}" v-text="row.sfContext" style="white-space:normal;line-height:1.8;"></div>
	  <div slot="sfContact" slot-scope="{row}" v-text="row.sfContact" style="max-height: 30vh;overflow: hidden;max-width: 99%;"></div>
    <div slot="sfImageArray" slot-scope="{row}"  style="max-height:30vh;overflow:auto;max-width:99%;" class="fCenter" >
       <img :src="img" alt="" loading="lazy"
          v-for="img in
            typeof row.sfImageArray == 'string'
              ? ( row.sfImageArray = window.JSON.parse(row.sfImageArray) )
              : row.sfImageArray"
          onclick="document.PreviewVideo(this.src)" :title="'点击预览 ' + img"
          :key="img"
          />
    </div>

     <div slot="createtime" slot-scope="{row}" v-text="row.createtime" style="max-height: 30vh;overflow: hidden;max-width: 99%;"></div>




	</mytable>
 </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: "",
      sfStatus:"",
      sfStatusAll:[
        {id:1,name:"未读"},
        {id:2,name:"已读"},

      ],
      input:"",
      userId: null,

      tableColums_getSysKeyList: {
        $selection: false,
        sfContext: '反馈内容',
        sfContact: ["用户手机号",130],
        sfImageArray:'反馈图片',
        createtime:['反馈时间',200],
        sfStatus: ['状态',90,'@v-if: 1:未读#danger, 2:已读#success'],

        $operation: [
          '操作', 120,
          this.updateSysFeedbackStatus && `@text: 标记已读#success
           @click: _confirm('确定要标记已读该反馈记录吗?')
                   .trigger('updateSysFeedbackStatus',{sfId:$row.sfId})
                   .trigger('getSysFeedbackList')
          `,
        ],

      },

    };
  },

  watch: {
    superEditor(superEditor) {
      superEditor.focus();
    },
  },

  methods: {
   sfStatusChange(e){
      this.sfStatus=e;
      this.getSysFeedbackList({sfStatus:this.sfStatus});
    },
    theProjectAllChange(e){
        this.theProjectId=e;
        this.getSysFeedbackList({projectId:this.theProjectId});
    },

  },

  created() {
      this.getSysFeedbackList();
       this.getProjectList({pageSize:0});
  },

};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/help/feedback.vue